var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProperty1Consultancy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 76,
    viewBox: "0 0 109 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_144_222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109 21.9214C108.646 22.6964 108.049 23.3333 107.301 23.7342C106.553 24.1351 105.695 24.2779 104.858 24.1407C101.706 24.1407 98.5997 24.1407 95.4931 24.1407C94.3621 24.1143 93.2542 24.4646 92.3415 25.1371C89.9403 26.8582 87.5091 28.534 85.0478 30.1645C84.2374 30.708 83.337 31.5233 82.3014 30.5721C81.2659 29.621 81.8062 28.7151 82.3014 27.7187L83.6971 24.186C82.8824 23.8551 82.2076 23.2492 81.7886 22.4723C81.3696 21.6954 81.2325 20.796 81.401 19.9285C81.401 16.2146 81.401 12.5459 81.401 8.87725C81.3451 8.41362 81.3932 7.94328 81.5418 7.50081C81.6904 7.05835 81.9356 6.65501 82.2596 6.32046C82.5835 5.9859 82.9778 5.72864 83.4136 5.56758C83.8494 5.40652 84.3155 5.34575 84.7777 5.38976H105.623C106.392 5.3386 107.154 5.55325 107.785 5.9981C108.416 6.44295 108.876 7.09127 109.09 7.83553L109 21.9214ZM86.9838 24.7295C88.6496 23.6424 90.1354 22.5554 91.7562 21.6496C92.5654 21.1833 93.48 20.9338 94.4126 20.9249C97.5191 20.9249 100.581 20.9249 103.687 20.9249H105.578V8.74138H84.6876V20.7891C87.2089 20.8796 88.2895 21.4231 86.9838 24.7295Z",
    fill: "url(#paint0_linear_144_222)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8021 57.6567C49.8401 57.6567 45.9231 57.6567 41.9611 57.6567C40.3403 57.6567 39.8451 57.2491 39.755 55.6186C39.2667 48.1963 37.0786 40.9882 33.3618 34.5578C31.3763 31.1045 30.361 27.1734 30.4244 23.1846C30.4879 19.1958 31.6277 15.2994 33.722 11.9118C36.1353 7.74381 39.7692 4.42725 44.127 2.41544C48.4848 0.403624 53.3539 -0.205276 58.0688 0.671962C62.7836 1.5492 67.1141 3.86977 70.4684 7.31649C73.8226 10.7632 76.037 15.1679 76.8087 19.9285C77.6865 25.0592 76.7803 30.3376 74.2424 34.8748C71.8979 38.7165 70.166 42.9039 69.1098 47.2848C68.6146 49.9571 68.2094 52.6746 67.9392 55.4374C67.6691 57.4755 67.354 57.8379 65.2829 57.8379L53.8021 57.6567ZM64.6076 54.3504C64.6076 53.9428 64.6076 53.6257 64.6076 53.3087C64.8784 49.3991 65.7282 45.5521 67.1288 41.8951C68.4795 38.5888 70.1453 35.373 71.6311 32.1573C73.5104 28.4424 74.1121 24.2053 73.342 20.1096C72.4486 14.8923 69.546 10.2398 65.2641 7.16184C60.9822 4.08385 55.6665 2.82866 50.4704 3.66864C45.308 4.52874 40.6782 7.36915 37.5547 11.5925C34.4312 15.8159 33.0573 21.0932 33.722 26.3146C34.4231 29.398 35.6411 32.3388 37.3238 35.0107C39.4187 38.6631 40.9375 42.6204 41.8261 46.7413C42.3213 49.2324 42.6815 51.7235 43.0867 54.2598L64.6076 54.3504Z",
    fill: "url(#paint1_linear_144_222)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4377 24.0953L27.1036 28.6245C27.2105 28.9568 27.2116 29.3144 27.1067 29.6474C27.0018 29.9803 26.796 30.2719 26.5183 30.4815C26.2273 30.7246 25.861 30.8577 25.4827 30.8577C25.1045 30.8577 24.7382 30.7246 24.4472 30.4815C21.8809 28.7151 19.2696 26.994 16.7033 25.1824C15.6833 24.3655 14.404 23.9472 13.1015 24.0048C9.85986 24.0048 6.66324 24.0048 3.42161 24.0048C2.93106 24.0821 2.42929 24.0418 1.95716 23.8871C1.48504 23.7324 1.05592 23.4676 0.70481 23.1144C0.3537 22.7612 0.0905347 22.3296 -0.0632648 21.8546C-0.217064 21.3797 -0.257139 20.8749 -0.180208 20.3814V8.87723C-0.237156 8.40347 -0.187057 7.9229 -0.0336555 7.47134C0.119746 7.01978 0.372499 6.60888 0.705754 6.26928C1.03901 5.92967 1.44416 5.67013 1.89102 5.51C2.33788 5.34987 2.81491 5.29328 3.28654 5.34445H24.042C24.5136 5.29328 24.9907 5.34987 25.4375 5.51C25.8844 5.67013 26.2896 5.92967 26.6228 6.26928C26.9561 6.60888 27.2088 7.01978 27.3622 7.47134C27.5156 7.9229 27.5657 8.40347 27.5088 8.87723C27.5088 12.5912 27.5088 16.3051 27.5088 20.0191C27.6658 20.8336 27.5471 21.6776 27.1718 22.4164C26.7964 23.1552 26.1859 23.7463 25.4377 24.0953ZM24.3121 20.789V8.74135H3.42161V20.8796C7.15849 20.8796 10.8053 20.8796 14.4522 20.8796C15.4736 20.8429 16.481 21.1279 17.3336 21.6949C18.8194 22.7366 20.3501 23.6877 21.8359 24.7294C21.2506 21.0608 21.2506 21.0608 24.3121 20.789Z",
    fill: "url(#paint2_linear_144_222)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7571 63.4541H41.7361C40.4754 63.4541 39.7551 62.7747 39.8001 61.6877C39.8451 60.6007 40.5204 60.1478 41.691 60.1025H65.6431C67.0388 60.1025 67.6692 60.6007 67.7592 61.6877C67.8493 62.7747 67.1289 63.4541 65.7782 63.4541H53.7571Z",
    fill: "url(#paint3_linear_144_222)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7571 69.7044H43.5369C42.3213 69.7044 41.6459 69.0703 41.691 68.0286C41.6716 67.8292 41.6948 67.628 41.7591 67.4384C41.8234 67.2489 41.9272 67.0753 42.0637 66.9295C42.2001 66.7836 42.366 66.6688 42.5503 66.5928C42.7345 66.5167 42.9327 66.4813 43.1317 66.4887C43.8664 66.4433 44.6031 66.4433 45.3378 66.4887H63.9322C64.8326 66.4887 65.598 66.4887 65.9132 67.5757C66.2284 68.6627 65.508 69.7044 64.1573 69.7497L53.7571 69.7044Z",
    fill: "url(#paint4_linear_144_222)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8473 75.7735H46.5086C45.2029 75.7735 44.5276 75.1394 44.5276 74.0977C44.5276 73.056 45.2479 72.5125 46.5086 72.4672H61.0509C62.4016 72.4672 63.0319 73.056 63.0319 74.1883C63.0319 75.3206 62.5367 75.7735 61.096 75.7735H53.8473Z",
    fill: "url(#paint5_linear_144_222)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0429 19.2038H88.7848C87.5692 19.2038 86.8488 18.5697 86.8938 17.528C86.9389 16.4863 87.5692 15.8975 88.7848 15.8975H101.436C102.697 15.8975 103.372 16.4863 103.417 17.4827C103.462 18.4792 102.742 19.2038 101.436 19.2038H95.0429Z",
    fill: "url(#paint6_linear_144_222)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.133 13.6782H88.8748C87.5692 13.6782 86.8488 13.0441 86.8938 12.0024C86.9389 10.9607 87.5692 10.3719 88.9198 10.3719H101.346C102.697 10.3719 103.372 10.9154 103.417 11.9571C103.462 12.9988 102.697 13.6782 101.301 13.6782H95.133Z",
    fill: "url(#paint7_linear_144_222)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0769 14.0858L64.6077 13.2706C64.7776 13.1511 64.9712 13.0698 65.1751 13.0325C65.3791 12.9951 65.5887 13.0025 65.7896 13.0541C65.9905 13.1057 66.178 13.2003 66.3392 13.3315C66.5004 13.4626 66.6316 13.6272 66.7237 13.8141C67.5792 15.2634 68.4796 16.7128 69.245 18.3433C69.3473 18.536 69.405 18.7495 69.4138 18.9678C69.4225 19.1861 69.382 19.4036 69.2954 19.604C69.2088 19.8043 69.0783 19.9824 68.9137 20.1249C68.749 20.2674 68.5544 20.3705 68.3446 20.4267C66.9939 21.0155 66.9939 21.9213 67.1289 23.1442C67.2412 24.2434 67.2412 25.3513 67.1289 26.4506C67.0567 26.6849 67.0772 26.9382 67.1863 27.1577C67.2954 27.3771 67.4845 27.5457 67.7142 27.6281H68.0744C69.6952 28.6246 69.8753 29.1228 68.9298 30.8439L67.0389 34.1049C66.3185 35.2372 65.6882 35.4637 64.4726 34.8749C64.0506 34.6803 63.6442 34.4531 63.257 34.1955L58.3045 36.8677C58.1956 36.9379 58.1031 37.0309 58.0332 37.1403C57.9633 37.2498 57.9176 37.373 57.8993 37.5018C57.8993 37.9094 57.8993 38.3623 57.8993 38.77C57.8993 40.174 57.359 40.5364 55.9183 40.5817H51.7762C50.3805 40.5817 49.8852 40.0382 49.9753 38.6341C50.068 38.1419 49.964 37.6328 49.6858 37.2173C49.4077 36.8017 48.9778 36.5134 48.4895 36.4148C47.394 35.9119 46.3655 35.2728 45.428 34.5125C45.2512 34.3836 45.0385 34.3142 44.8202 34.3142C44.6019 34.3142 44.3891 34.3836 44.2124 34.5125C41.8712 35.7354 41.556 35.6448 40.2504 33.3349L38.6295 30.4815C37.9092 29.2134 37.9992 28.4434 39.2599 27.8093C39.5177 27.718 39.755 27.5763 39.9581 27.3923C40.1613 27.2083 40.3262 26.9857 40.4434 26.7373C40.5606 26.4889 40.6277 26.2196 40.641 25.9449C40.6542 25.6703 40.6133 25.3957 40.5205 25.1371C40.4308 24.0066 40.4308 22.8707 40.5205 21.7402C40.5196 21.534 40.4749 21.3304 40.3895 21.1429C40.3041 20.9555 40.1799 20.7885 40.0253 20.6532C37.8191 19.2491 37.7291 18.9321 39.0798 16.6222C39.53 15.7616 40.0253 14.9464 40.5205 14.1311C41.0158 13.3159 42.0513 12.4553 43.2669 13.2706C43.6208 13.6219 44.0979 13.8188 44.5951 13.8188C45.0922 13.8188 45.5694 13.6219 45.9232 13.2706C46.8936 12.5975 47.9356 12.0354 49.0298 11.5948C49.5251 11.3683 49.7952 11.1418 49.7952 10.5531C49.7952 7.92612 50.1103 7.69965 52.6766 7.65436H55.4681C57.2239 7.65436 57.8092 8.10728 57.7192 9.82838C57.6291 11.5495 58.1694 11.4589 59.1599 11.8665C60.1504 12.2741 61.7262 13.2706 63.0769 14.0858ZM53.2169 11.0513C53.196 11.2772 53.196 11.5047 53.2169 11.7306C53.2169 13.6329 52.9018 13.7688 51.1459 14.4029C49.7603 14.9218 48.4563 15.6387 47.2739 16.5316C44.9778 18.4792 45.1128 18.2074 43.0418 17.0751L42.4565 18.1168L43.0868 18.5244C44.6176 19.4756 44.6176 19.7926 44.3024 21.6043C44.0546 22.9973 44.0546 24.4235 44.3024 25.8165C44.6626 27.7187 44.9778 29.3945 42.4565 30.0286L43.2219 31.2515L43.8072 30.9345C45.473 29.9833 45.6531 30.1192 47.1389 31.3421C48.3309 32.2806 49.6309 33.0713 51.0108 33.6973C52.9468 34.5125 53.5771 34.1502 53.5321 36.9583C53.5126 37.0478 53.5126 37.1405 53.5321 37.23H54.7477C54.7477 36.9583 54.7477 36.6865 54.7477 36.4601C54.7477 34.6484 55.0178 34.4672 56.7287 33.8331C58.1092 33.3862 59.3927 32.6792 60.5106 31.7497C61.9063 30.4815 63.167 29.8474 65.0129 31.1609H65.283L65.8683 30.0739L65.283 29.6663C63.6622 28.6699 63.6622 28.4434 63.9773 26.5411C64.2292 25.042 64.2292 23.511 63.9773 22.0119C63.4821 19.1132 63.9773 19.2944 65.5982 18.2527V17.9809L64.8328 16.8939L64.2025 17.1657C62.4466 18.1168 62.3115 17.9809 60.7807 16.7581C59.648 15.7938 58.3718 15.0143 56.9988 14.4482C54.7027 13.497 54.6576 13.5876 54.4775 11.0966L53.2169 11.0513Z",
    fill: "url(#paint8_linear_144_222)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.822 19.2038H7.47377C6.25815 19.2038 5.53778 18.5245 5.5828 17.4827C5.62783 16.441 6.25814 15.8975 7.42873 15.8975H20.3052C21.4758 15.8975 22.1062 16.5316 22.1062 17.528C22.1062 18.5245 21.4758 19.1585 20.3052 19.2038H13.822Z",
    fill: "url(#paint9_linear_144_222)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9121 10.3719H20.2153C21.4309 10.3719 22.1062 10.9607 22.1062 12.0024C22.1062 13.0441 21.4759 13.6782 20.2153 13.6782H7.47385C7.23313 13.7114 6.9881 13.6912 6.75596 13.6191C6.52381 13.5469 6.31017 13.4246 6.13001 13.2606C5.94984 13.0966 5.80749 12.895 5.71298 12.6698C5.61847 12.4446 5.57407 12.2014 5.58288 11.9571C5.58288 10.9607 6.30325 10.3719 7.51886 10.3719H13.9121Z",
    fill: "url(#paint10_linear_144_222)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1763 24.1859C62.1763 26.4244 61.2955 28.5718 59.7263 30.1589C58.1571 31.7459 56.0272 32.6436 53.8021 32.6555C51.5609 32.6317 49.4196 31.7193 47.8432 30.1165C46.2668 28.5137 45.3827 26.35 45.3828 24.0953C45.4066 21.8569 46.3103 19.719 47.8963 18.1489C49.4824 16.5788 51.6219 15.7042 53.8471 15.7163C54.9485 15.7162 56.039 15.9359 57.0555 16.3627C58.0719 16.7894 58.9942 17.4147 59.7688 18.2024C60.5434 18.9901 61.1551 19.9245 61.5683 20.9516C61.9815 21.9787 62.1882 23.078 62.1763 24.1859ZM53.8471 29.2586C55.1964 29.2586 56.4905 28.7194 57.4446 27.7596C58.3987 26.7998 58.9346 25.498 58.9346 24.1406C58.9346 22.7832 58.3987 21.4815 57.4446 20.5217C56.4905 19.5618 55.1964 19.0226 53.8471 19.0226C53.1722 18.9972 52.4994 19.1122 51.8707 19.3604C51.242 19.6086 50.671 19.9847 50.1935 20.4651C49.7159 20.9455 49.3421 21.5199 49.0953 22.1524C48.8486 22.7848 48.7343 23.4617 48.7595 24.1406C48.7274 24.8213 48.837 25.5012 49.0813 26.1368C49.3256 26.7724 49.6993 27.3496 50.1782 27.8314C50.6572 28.3133 51.231 28.6891 51.8628 28.9349C52.4946 29.1807 53.1705 29.2909 53.8471 29.2586Z",
    fill: "url(#paint11_linear_144_222)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_144_222",
    x1: 93.6054,
    y1: 24.6625,
    x2: 109.147,
    y2: 24.5202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2F01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_144_222",
    x1: 51.0774,
    y1: 43.5858,
    x2: 77.2315,
    y2: 43.4065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2F01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_144_222",
    x1: 12.072,
    y1: 24.5356,
    x2: 27.6331,
    y2: 24.3924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2F01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_144_222",
    x1: 52.1653,
    y1: 62.6242,
    x2: 67.7478,
    y2: 61.5253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2F01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_144_222",
    x1: 52.4304,
    y1: 68.9338,
    x2: 65.9848,
    y2: 68.0889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2F01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_144_222",
    x1: 52.7099,
    y1: 74.9548,
    x2: 63.0475,
    y2: 74.4659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2F01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_144_222",
    x1: 94.1999,
    y1: 18.3851,
    x2: 103.437,
    y2: 17.9949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2F01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_144_222",
    x1: 94.1999,
    y1: 12.8595,
    x2: 103.437,
    y2: 12.4693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2F01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_144_222",
    x1: 52.0292,
    y1: 32.4282,
    x2: 69.5684,
    y2: 32.2872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2F01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_144_222",
    x1: 12.888,
    y1: 18.3851,
    x2: 22.1243,
    y2: 17.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2F01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_144_222",
    x1: 12.8886,
    y1: 12.8712,
    x2: 22.1245,
    y2: 12.4829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2F01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_144_222",
    x1: 52.8088,
    y1: 28.461,
    x2: 62.2113,
    y2: 28.3823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2F01"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_144_222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 109,
    height: 76,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProperty1Consultancy);
export default __webpack_public_path__ + "static/media/Property 1=Consultancy.379add60892ffbf778fc4d2faa7d7c90.svg";
export { ForwardRef as ReactComponent };